import { render, staticRenderFns } from "./CreateBookingView.vue?vue&type=template&id=0d4b72d4&scoped=true"
import script from "./CreateBookingView.vue?vue&type=script&lang=js"
export * from "./CreateBookingView.vue?vue&type=script&lang=js"
import style0 from "./CreateBookingView.vue?vue&type=style&index=0&id=0d4b72d4&prod&lang=scss&scoped=true"
import style1 from "./CreateBookingView.vue?vue&type=style&index=1&id=0d4b72d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4b72d4",
  null
  
)

export default component.exports